import { lazy } from "react";

const Kiosque = lazy(() => import("./Kiosque"));
const KiosquePos = lazy(() => import("./KiosquePos"));

const kiosqueRoutes = [
    {
      path: "/kiosque",
      component: Kiosque
    },
    {
      path: "/pos/kiosque/:company_id/:caisse_id",
      component: KiosquePos
    },
  ];
  
  export default kiosqueRoutes;